// @flow
import { isNearlyInt } from './number';

/**
 * Convert days value to days, months or years on better fit
 * @param days value
 * @returns {string} days, months or years value (truncated to int as string)
 */
export const durationValue = (days: number): string => {
  const years = days / 365;
  if (isNearlyInt(years)) {
    return years.toFixed(0);
  }
  const months = days / 30;
  if (isNearlyInt(months)) {
    return months.toFixed(0);
  }
  return days.toFixed(0);
};

/**
 * Get days label of days, months or years on better fit
 * @param days value
 * @returns {string} days, months or years label
 */
export const durationLabel = (days: number): string => {
  const years = days / 365;
  if (years > 0.5 && isNearlyInt(years)) {
    return years < 2 ? 'Year' : 'Years';
  }
  const months = days / 30;
  if (months > 0.5 && isNearlyInt(months)) {
    return months < 2 ? 'Month' : 'Months';
  }
  return days === 1 ? 'Day' : 'Days';
};

export const mergeObjects = (o1: any, o2: any): any => {
  const merged = o1;
  for (const key of Object.keys(o2)) {
    if (typeof(merged[key]) === 'object') {
      merged[key] = mergeObjects(merged[key], o2[key]);
    } else {
      merged[key] = o2[key];
    }
  }
  return merged;
};
